var React = require('react');

function PrevArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"st0","cx":"30","cy":"30","r":"29","key":0}),React.createElement("path",{"className":"st0","d":"M40.5,15.7L19.5,30l21.1,14.3","key":1})]);
}

PrevArrow.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 60 60","style":{"enableBackground":"new 0 0 60 60"},"xmlSpace":"preserve"};

module.exports = PrevArrow;

PrevArrow.default = PrevArrow;
